import http from "../http";

export default {
  /* 获取文章列表 */
  getArticleList(params) {
    return http.get(`/wx_authorization/get_mp_article`, params, {
      loading: true,
    });
  },
}